import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsPlaystation4Component } from './simple-icons-playstation4.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsPlaystation4Component ],
    exports:      [ SimpleIconsPlaystation4Component ],
    bootstrap:    []
})
export class SimpleIconsPlaystation4Module {}
